import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        tab: {
            fontSize: '12px !important',
            padding: `0 ${theme.spacing(1)} !important`,
            minHeight: `${theme.spacing(4.5)} !important`,
            letterSpacing: 'unset !important',
            color: `${theme.palette.secondary[700]} !important`,
            fontWeight: '500 !important',
        },
        selectedTab: {
            color: `${theme.palette.primary.main} !important`,
        },
    }
})

export default useStyles
